<template>
  <b-modal
    id="confirm-modal"
    ref="modal"
    class="modal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
  >
    <template #modal-header>
      <div class="upper">
        <h3>{{title}}</h3>
      </div>
      <button
        class="close"
        @click="hide()"
      >
        ×
      </button>
    </template>

    <form-component>
      <p v-if="confirmBody">{{confirmBody}}</p>
      <p v-else-if="bodyText">{{bodyText}}</p>
    </form-component>

    <template slot="modal-footer">
      <button
        class="btn"
        type="button"
        @click="hide()"
      >
        {{cancelText}}
      </button>
      <button
        :disabled="saving"
        class="btn btn--primary"
        type="button"
        @click="doConfirm()"
      >
        <font-awesome-icon
          v-if="saving"
          :spin="true"
          :icon="['fas', 'spinner']"
          class="icon alt"
        />
        <span v-else>{{confirmText}}</span>
      </button>
    </template>
  </b-modal>

</template>

<script>
  import FormComponent from '@/components/FormComponent';

  export default {
    name: 'ConfirmModal',
    components: {
      FormComponent,
    },
    props: {
      confirmText: {
        type: String,
        default: 'Yes'
      },
      cancelText: {
        type: String,
        default: 'Cancel'
      },
      confirmBody: {
        type: String,
      },
      title: {
        type: String,
      },
      onConfirm: {
        type: Function,
      },
    },
    data() {
      return {
        saving: false,
        bodyText: null,
      };
    },
    methods: {
      show(model, bodyText) {
        this.bodyText = bodyText;
        this.$refs.modal.show();
        this.model = model;
      },
      hide() {
        this.bodyText = null;
        this.saving = false;
        this.$refs.modal.hide();
      },

      doConfirm() {
        this.saving = true;
        this.$emit('ok', this.model);
        if(this.onConfirm)
          this.onConfirm();
      },
    },
  };
</script>

<style lang="scss" scoped>

</style>
